(() => {
  function enhancePolicyOutline(root = document) {
    const main = root.querySelector?.('#MainContent');
    if (!main || !(main.querySelector('.shopify-policy__body') || main.matches('[data-template="page.avino-policy"], [data-page-handle="shipping-delivery"], [data-page-handle="payment-information"]'))) return;
    main.querySelectorAll('.shopify-policy__body p, .avino-page__content p').forEach((paragraph) => {
      if (/^\s*\d+[.)]\s+\S/.test(paragraph.textContent || '')) paragraph.classList.add('avino-policy-section-title');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhancePolicyOutline(), { once: true });
  else enhancePolicyOutline();
  document.addEventListener('shopify:section:load', () => enhancePolicyOutline());
})();
